export * from './ArticleSummary_Vertical'
